var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.499 8.5h-3v1.324l.002.01v3.126l.81-.815a.501.501 0 01.757.65l-.048.057-1.662 1.668a.503.503 0 01-.653.05l-.056-.05-1.67-1.666a.5.5 0 01.653-.755l.056.048.811.81V8.5h-4.46l.816.811a.501.501 0 01-.65.757l-.057-.049L1.48 8.358a.503.503 0 01-.05-.652l.049-.057L3.146 5.98a.5.5 0 01.755.652l-.048.056-.81.812h4.455L7.5 3.04l-.811.815a.501.501 0 01-.757-.65l.049-.057L7.642 1.48a.503.503 0 01.652-.05l.056.05 1.67 1.666a.5.5 0 01-.652.756l-.056-.049-.812-.81V7.5h4.46l-.815-.811a.5.5 0 01.65-.757l.056.049 1.669 1.662a.503.503 0 01.049.652l-.048.057-1.667 1.669a.5.5 0 01-.756-.652l.049-.056.81-.811-1.449-.001h-.01z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMove);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconMove.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };